<template>
  <div style="width: 100%; border: 1px solid #f1f1f1;padding: 20px 20px;margin-bottom: 10px;">
    <el-row type="flex" align="middle">
      <!-- <el-col :span="1.6">
        <el-avatar class="school_logo" :size="60" style="margin-top: 10px;margin-right: 10px;" :src="item.logo" />
      </el-col> -->
      <el-col :span="17">
        <p class="row" style="color:#adadad">
          <span style="margin-right: 2px;font-size: 18px; color: black;">{{ item.name }}</span>
          <span style="font-size: 18px;margin-left: 5px;color: black;" v-if="item.group_name">【{{ item.group_name
          }}】</span>
          <span v-if="item.school_tip">
            {{ item.school_tip }} |
          </span>
          <span v-if="item.nature">{{ item.nature }} | </span>
          <span v-if="item.school_type">{{ item.school_type }} | </span>
          <span v-if="item.school_belong"> {{ item.school_belong }} |</span>
          <span v-if="item.address" style=" white-space: nowrap">
            <el-tooltip class="item" :content="item.address" placement="top-end" effect="light">
              <span> {{ item.address }} | </span>
            </el-tooltip>
          </span>
          <span v-if="item.baoyan">保研 | </span>
          <span v-if="item.ruanke">排名：{{ item.ruanke }}</span>
        </p>
        <p style="margin-top: 10px;">{{ item.specialty_name }}</p>
        <p style="color:#adadad;margin-top: 10px;font-size: 16px;  white-space: nowrap;overflow: hidden;
  text-overflow: ellipsis; ">
          <span>院校代码：<span style="color: #000000;">{{ item.school_id }}</span></span>
          <span style="margin-left: 15px;">招生计划： <span style="color: #000000;"> {{ item.plan_num }}</span> </span>
          <span style="margin-left: 15px;">选科要求：<span style="color: #000000;">{{ item.demand }}</span></span>
          <span style="margin-left: 15px;">专业代码：<span style="color: #000000;">{{ item.specialty_id }}</span></span>
          <span style="margin-left: 15px;"><span style="color: #adadad;">{{ item.pici }}</span></span>
        </p>
        <p style="color:#adadad;margin-top: 10px;font-size: 16px;  white-space: nowrap;overflow: hidden;
  text-overflow: ellipsis; ">
          <span>专业信息：<span style="color: #000000;">{{ item.remarks }}</span></span>
        </p>
      </el-col>
      <el-col :span="4" :offset="3" style="text-align: right;">
        <el-popover popper-class="popover-f" placement="bottom" :trigger="popTrigger">
          <div class="popover-box">
            <p class="box-title">志愿位置</p>
            <span v-for="h in len" :key="h" class="box-item" @click="chooseCollege(item, h)">
              <span v-if="record.id_list[h - 1] != ''" class="box-item-box"
                style="background: #fbbfbb; border: #fbbfbb;">{{ h }}</span>
              <span v-else class="box-item-box">{{ h }}</span>
            </span>
          </div>

          <el-button size="medium" v-if="record.id_list.indexOf(item.id) > -1" slot="reference" type="primary">
            志愿{{ record.id_list.indexOf(item.id) + 1 }}
          </el-button>
          <el-button v-else slot="reference" size="medium">填报为</el-button>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    item: Object,
    userInfo: Object,
    state: Number,
    record: Object
  },
  data() {
    return {
      collegeData: [],
      dialogVisible: false,
      len: 64,
      popTrigger: 'hover'
    };
  },
  components: {
  },
  filters: {
    Zero(e) {
      if (e > -100) {
        return e;
      } else {
        return "-";
      }
    },
  },
  watch: {
    state() {
      this.$forceUpdate();
    }
  },

  methods: {
    //填报学校
    chooseCollege(item, i) {
      let ids = this.record.id_list.indexOf(item.id)

      //重复选删除
      if (item.id == this.record.id_list[i - 1]) {
        this.record.table[ids] = {
          name: "暂无",
        }
        this.record.id_list[ids] = ''
      } else {
        //如果这个学校在其他位置填过就删除
        if (ids > -1) {
          this.record.table[ids] = {
            name: "暂无",
          }
          this.record.id_list[ids] = ''
        }
        //添加这个位置的志愿
        this.record.table[i - 1] = item
        this.record.id_list[i - 1] = item.id
      }


      //更新数据流
      this.$emit('refush', this.record)
    },
  },
};
</script>

<style scoped lang='less'>
.tb1 {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
  border: 1px solid #dbdbdb;
  border-bottom: 0px;

  tbody {
    line-height: 28px;

    .bg_line {
      background: #f4f7fc;
    }
  }
}

//选择志愿框</style>


<style lang="less">
.popover-f {
  width: 350px;
  color: black;
  min-width: 0;

  .box-title {
    color: #459df5;
    padding-bottom: 10px;
    border-bottom: 1px solid white;
  }

  .box-item {
    display: inline-block;
  }

  .box-item-box {
    display: inline-block;
    font-size: 14px;
    color: #707070;
    border-radius: 3px;
    background: #daedfc;
    margin: 3px 3px;
    width: 30px;
    line-height: 30px;
    height: 30px;
    text-align: center;
    border: 1px solid #daedfc;
  }

  .box-item-box:hover {
    display: inline-block;
    color: #459df5;
    background: white;
    border: 1px solid #459df5;
  }
}

.mojarDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>